<template>
  <div class="PaymentDetail  w-full sm:py-12 " :class="isVertical == 'true' ? '' : 'sm:border-t sm:border-b sm:border-grey2 mt-24 sm:mt-28 '">
    <div class="flex" :class="isVertical == 'true' ? 'flex-col' : 'flex-col sm:flex-row sm:flex-wrap'">
      <div v-show="value" class="pb-12 sm:py-12" :class="isVertical == 'true' ? 'w-full' : 'w-full sm:w-6/12'" v-for="(value, name, index) in data"  :key="index">
        <p class="text-grey uppercase text-14 font-bold">
          {{ $t(`payment-detail.${name}`) }}
        </p>
        <p 
          v-if="name === 'validity'"
          :class="[isPaymentExpired ? 'text-red font-bold' : '']"
          class="text-grey text-14 font-medium">
            {{ isPaymentExpired ? $i18n.t('expired') : value}}
        </p>
        <p v-else class="text-grey text-14 font-medium" v-html="value"></p>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'PaymentDetail',
  props: {
    data : {
      type: Object,
      required: true
    },
    isVertical : {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters('linkToPay', [
      'isPaymentExpired'
    ])
  }
})
</script>